"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);
var _bus = require('shared/services/bus'); var _bus2 = _interopRequireDefault(_bus);



// Files waiting in each chat's tray, kept for the session as its text draft is,
// so switching chats doesn't lose them. In memory only, never in browser
// storage: they're patient files and clinics share computers, so a reload,
// closing the app or logging out drops them. Previews are object URLs that
// AttachmentTray makes and revokes while it shows a file, so nothing here
// holds one.
const staged = new Map()
// Tray ids stay unique across chats and screen remounts.
let nextId = 0
// Counts logouts. A screen still open at logout unmounts after the map is
// cleared, and its cleanup would put the last user's files back, so a write
// from before the last logout is dropped.
let session = 0

 const stagedFiles = {
  get: (key) => _nullishCoalesce(staged.get(key), () => ( [])),
  // The session a screen read its files in; pass it back when saving them.
  session: () => session,
  set: (key, files, from) => {
    if (from !== session) return
    if (files.length) staged.set(key, files)
    else staged.delete(key)
  },
  clearAll: () => {
    staged.clear()
    session++
  },
  nextId: () => nextId++,
}; exports.stagedFiles = stagedFiles

_bus2.default.on(_actionCreators2.default.logoutAction.type, exports.stagedFiles.clearAll)
